import { AfterViewInit, Directive } from '@angular/core';
import { DOWN_ARROW, SHIFT, TAB, UP_ARROW } from '@angular/cdk/keycodes';
import { MatAutocomplete } from '@angular/material/autocomplete';

@Directive({
    selector: '[tab-selected]',
    standalone: false
})
export class TabSelected implements AfterViewInit {
  constructor(private auto: MatAutocomplete) {}
  ngAfterViewInit() {
    this.auto._keyManager.onKeydown = (event: KeyboardEvent) => {
      switch (event.keyCode) {
        case TAB:
          if (this.auto.isOpen) {
            const option = this.auto.options.find(x => x.active);
            if (option) {
              option.setActiveStyles();
              option.focus();
              return;
            }
          }
          this.auto._keyManager.setNextItemActive();
          break;
        case DOWN_ARROW:
          this.auto._keyManager.setNextItemActive();
          break;
        case UP_ARROW:
          this.auto._keyManager.setPreviousItemActive();
          break;
      }
    };
  }
}
